// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__xPaIY","container":"Footer_container__R0lDr","section":"Footer_section__ThTWT","copyright":"Footer_copyright__dTGBe"};